import axios from './_nestAxios'

export const obtenerxId = (id) => axios.get(`/ubicaciones-almacenamiento/${id}`)

export const obtenerxEstanteria = (idEstanteria) =>
  axios.get('/ubicaciones-almacenamiento', { params: { idEstanteria } })

export const getUbicacionesAlmacenamiento_Select = (idAlmacen) =>
  axios.get('/ubicaciones-almacenamiento', {
    params: { tipoConsulta: 'select', idAlmacen: idAlmacen || undefined }
  })

export const actualizarUbicacion = (id, data) =>
  axios.put(`/ubicaciones-almacenamiento/${id}`, data)

export const asignarItem = (id, data) =>
  axios.post(`/ubicaciones-almacenamiento/${id}/items`, data)

export const actualizarItem = (id, idItem, data) =>
  axios.put(`/ubicaciones-almacenamiento/${id}/items/${idItem}`, data)

export const eliminarItem = (id, idItem) =>
  axios.delete(`/ubicaciones-almacenamiento/${id}/items/${idItem}`)

export const moverItem = (idOrigen, idItem, idDestino, cantidad) =>
  axios.post(`/ubicaciones-almacenamiento/${idOrigen}/items/${idItem}/mover`, {
    idDestino,
    cantidad: cantidad === undefined ? null : cantidad
  })

export const buscarProducto = (q) =>
  axios.get('/ubicaciones-almacenamiento/buscar/producto', { params: { q } })

export const descargarReporte = (idAlmacen) =>
  axios.get('/ubicaciones-almacenamiento/descargar/reporte', {
    responseType: 'blob',
    params: { idAlmacen: idAlmacen || undefined }
  })
